import { useDispatch, useSelector } from 'react-redux';
import { Link, Text } from '@beef/ui-kit';
import React, { useEffect } from 'react';
import classNames from 'classnames/bind';

import { getTradeInCalculatorButtonHref } from 'store/widgets/TradeInCalculator/selectors';
import { DeviceTypeSelect } from 'pages/SharedZone/components/TradeInNewCalculator/components/DeviceTypeSelect';
import { formatPrice } from 'utils/formatting';
import { getSharedZoneCalculateSettingsSettings } from 'store/SharedZone/selectors';
import { BrandSelect } from 'pages/SharedZone/components/TradeInNewCalculator/components/BrandSelect';
import { ModelSelect } from 'pages/SharedZone/components/TradeInNewCalculator/components/ModelSelect';
import { CapacitySelect } from 'pages/SharedZone/components/TradeInNewCalculator/components/CapacitySelect';
import { getTradeInDeviceMaxPrice } from 'store/widgets/TradeInNewCalculator/maxPrice/selectors';
import { fetchTradeInDeviceTypes } from 'store/widgets/TradeInNewCalculator/deviceType/actions';
import { tradeInSubmit } from 'store/widgets/TradeInNewCalculator/actions';
import { SelectWrapper } from 'pages/SharedZone/components/TradeInNewCalculator/components/SelectWrapper';

import style from './TradeInNewCalculator.module.pcss';

const cx = classNames.bind(style);

const TradeInNewCalculator = () => {
  const { maxPrice, buttonHref, calculateSettings } = useSelector((state) => ({
    maxPrice: getTradeInDeviceMaxPrice(state),
    buttonHref: getTradeInCalculatorButtonHref(state),
    calculateSettings: getSharedZoneCalculateSettingsSettings(state),
  }));

  const { calculateTitle, calculateDescription } = calculateSettings;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTradeInDeviceTypes());
  }, [dispatch]);

  return (
    <div className={cx('component')}>
      <div className={cx('column')}>
        <div className={cx('list')}>
          <SelectWrapper>
            <DeviceTypeSelect />
          </SelectWrapper>
          <SelectWrapper>
            <BrandSelect />
          </SelectWrapper>
          <SelectWrapper>
            <ModelSelect />
          </SelectWrapper>
          <SelectWrapper>
            <CapacitySelect />
          </SelectWrapper>
        </div>
        {!!calculateTitle && (
          <div className={cx('calculateTitle')}>
            <Text size="size4-m">{calculateTitle}</Text>
          </div>
        )}
        <div className={cx('price')}>
          <Text size="size1-b">{formatPrice(maxPrice)}₽</Text>
        </div>
        {buttonHref && (
          <div className={cx('toShopping')}>
            <Link variant="button" onClick={() => dispatch(tradeInSubmit())}>
              К покупкам
            </Link>
            {calculateDescription && (
              <div className={cx('calculateDescription')}>
                <Text size="size6-r">{calculateDescription}</Text>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TradeInNewCalculator;
